import {DomainEvent} from './DomainEvent';
import {News} from '../resources/News';

export class NewsUpdated extends DomainEvent<News> {}
